/**
 * 👇 Import this, if you want to check issues related to rendering.
 */
// import './wdyr'

import './polyfills'

import * as ReactDOM from 'react-dom'

import AppContainer from './AppContainer'

declare global {
  interface Window {
    // This function is only for the pre-rendering build step
    renderCB: () => void
  }
}

ReactDOM.render(<AppContainer />, document.getElementById('root'))
